const { default: axios } = require("axios");

$.Backend = {
    DownloadFile: (data, filename) => {
        const href = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    },

    SearchProduct: (search, language, details) =>
        axios.post("/product-search", {
            search,
            language,
            details: details === true ? 1 : 0,
        }),

    SearchMarketingDirectory: (search, language, details) =>
        axios.post("/product-search", {
            search,
            language,
            details: details === true ? 1 : 0,
        }),

    MarketingDirectoryDownloadBundle: (path, uuids) => {
        return new Promise((resolve, reject) => {
            axios({
                url: path,
                method: "POST",
                responseType: "blob",
                data: { uuids },
            })
                .then((response) => {
                    resolve();
                    $.Backend.DownloadFile(response.data, "bundle.zip");
                })
                .catch((error) => {
                    resolve();
                });
        });
    },

    MarketingDirectoryAdvancedSearch: (filters, page, language) =>
        axios.post("/marketing-directory/search", {
            filters,
            page,
            language,
        }),
};
